/* Vigilo dönüşüm öğeleri: stok, kazanç, kampanya sayacı */
(function () {
  'use strict';
  function money(cents) {
    var fmt = (window.vigilo && window.vigilo.moneyFormat) || '{{amount}} TL';
    var p = (cents / 100).toFixed(2).split('.');
    var dots = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var commas = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dots + ',' + p[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, dots)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, commas)
      .replace(/\{\{\s*amount\s*\}\}/, commas + '.' + p[1]);
  }
  function setupStock(section) {
    var el = section.querySelector('[data-stock]'); if (!el) return null;
    var map = {}; try { map = JSON.parse(el.querySelector('[data-stock-map]').textContent); } catch (e) {}
    var th = parseInt(el.getAttribute('data-threshold'), 10) || 15;
    var text = el.querySelector('[data-stock-text]'), bar = el.querySelector('[data-stock-bar]');
    return function (variantId) {
      var q = map[String(variantId)];
      var low = typeof q === 'number' && q > 0 && q <= th;
      el.classList.toggle('is-low', low);
      text.textContent = low ? el.getAttribute('data-low').replace('[sayi]', q) : el.getAttribute('data-ok');
      if (bar) { bar.hidden = !low; if (low) bar.firstElementChild.style.width = Math.max(6, Math.round(q * 100 / th)) + '%'; }
    };
  }
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var jsonEl = section.querySelector('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var idInput = section.querySelector('[data-variant-id]');
    var updateStock = setupStock(section);
    var savings = section.querySelector('[data-savings]');
    function sync() {
      if (!product || !idInput) return;
      var v = product.variants.find(function (x) { return String(x.id) === String(idInput.value); });
      if (!v) return;
      if (updateStock) updateStock(v.id);
      if (savings) {
        var saved = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price - v.price : 0;
        savings.hidden = saved === 0;
        if (saved) savings.querySelector('[data-savings-amount]').textContent = money(saved);
      }
    }
    if (updateStock && idInput) updateStock(idInput.value);
    var form = section.querySelector('[data-product-form]');
    if (form) form.addEventListener('change', function () { setTimeout(sync, 0); });
  });
  document.querySelectorAll('[data-campaign]').forEach(function (el) {
    var raw = (el.getAttribute('data-end') || '').trim().replace(' ', 'T');
    if (!/T\d{2}:\d{2}/.test(raw)) raw += 'T23:59';
    var end = new Date(raw + ':00+03:00').getTime();
    if (isNaN(end)) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var parts = { d: el.querySelector('[data-cd="d"]'), h: el.querySelector('[data-cd="h"]'), m: el.querySelector('[data-cd="m"]'), s: el.querySelector('[data-cd="s"]') };
    var timer;
    var tick = function () {
      var left = end - Date.now();
      if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
      el.hidden = false;
      var t = Math.floor(left / 1000);
      parts.d.textContent = pad(Math.floor(t / 86400));
      parts.h.textContent = pad(Math.floor(t % 86400 / 3600));
      parts.m.textContent = pad(Math.floor(t % 3600 / 60));
      parts.s.textContent = pad(t % 60);
    };
    tick(); timer = setInterval(tick, 1000);
  });
})();